export const DEBUG_COOKIE = "psc-debug"

export const USER_ID_UNKNOWN = 'UNKNOWN-USER-ID'
export const BODY_UNKNOWN = 'UNKNOWN-BODY'

export const DEFAULT_STICKY_HEADER_TOP_OFFSET = 340

